import _ from "lodash";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux";
import { deleteTimeslotCategory, loadCategoryTimeslot, UpdateFilterCategory } from "../../redux/reducer/timeslotReducer";
import BoxService from "./boxService"
import { loadListCalendar } from "../../redux/reducer/prenotationReducer";
import { useTranslation } from "react-i18next";
import ButtonIcon from "../common/buttonIcon";
import AlertMessageModal from "../alertMessageModal";
import { isGroupLinkActive, isGroupLinkChild, isGroupLinkNewActivation, isGroupLinkParent } from "../../utils/helpers";
import NewGroupLinkModal from "../common/newGroupLinkModal";


const ListServiceTimeslot = (props: any) => {
  const dispacth = useAppDispatch();
  const { t } = useTranslation();

  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);
  const { filter } = useSelector((state: any) => state.timeslot);
  const [errorMessage, setErrorMessage] = useState("");
  const [idDeleteCategoryPrenotation, setIdDeleteCategoryPrenotation] = useState("");
  const [nameDeleteCategoryPrenotation, setNameDeleteCategoryPrenotation] = useState("");
  const [loaderDelete, setLoaderDelete] = useState(false);
  const [groupLinkValueNewActivation, setGroupLinkValueNewActivation] = useState(null);

  // Reorder categories to show groups in a "parent-child" view.
  const reorderedCategories = [];
  for (let category of categoryPrenotation) {
    if (!isGroupLinkActive(category.groupLink) || isGroupLinkParent(category.groupLink)) {
      reorderedCategories.push(category);
      if (isGroupLinkParent(category.groupLink)) {
        for (let child of categoryPrenotation) {
          if (isGroupLinkChild(child.groupLink) && child.groupLink.value === category.groupLink.value) {
            reorderedCategories.push(child);
          }
        }
      }
    }
  }

  useEffect(() => {
    dispacth(loadCategoryTimeslot(true));
    // dispacth(loadListCalendar());
  }, []);

  useEffect(() => {
    findNewActivation(categoryPrenotation);
  }, [categoryPrenotation]);

  const findNewActivation = (timeslotCategories: any[]) => {
    for (let category of timeslotCategories) {
      if (isGroupLinkNewActivation(category.groupLink)) {
        const groupTimeslotCategories = timeslotCategories.filter(tc => tc.groupLink.value === category.groupLink.value);
        if (groupTimeslotCategories.length > 1) {
          setGroupLinkValueNewActivation(category.groupLink.value);
          return;
        }
      }
    }
  };

  const toggleviewListServiceTimeslot = (id: any, status: any) => {
    let timeslotcategorys = _.cloneDeep(filter);
    if (!status) {
      timeslotcategorys.push(id)
    }
    else {
      _.remove(timeslotcategorys, timeslotcategory => timeslotcategory === id);
    }
    dispacth(UpdateFilterCategory(timeslotcategorys))
  }
  const ClickEdit = (id: any) => {
    props.clickServiceEdit(id);
  }

  const ClickSettings = (id: any) => {
    props.clickServiceSettings(id);
  }
  const deleteCategoryPrenotation = (idTimeslotCategory: string, nameTimeslotCategory: string) => {
    setIdDeleteCategoryPrenotation(idTimeslotCategory);
    setNameDeleteCategoryPrenotation(nameTimeslotCategory)
  }

  const deleteTimeslotCategorie = async () => {
    try {
      setLoaderDelete(true);
      await dispacth(deleteTimeslotCategory(idDeleteCategoryPrenotation));
      await dispacth(loadCategoryTimeslot(false));
      setLoaderDelete(false);
      setIdDeleteCategoryPrenotation("");
      setNameDeleteCategoryPrenotation("");
    }
    catch (error: any) {
      setLoaderDelete(false);
      setIdDeleteCategoryPrenotation("");
      setErrorMessage(t(`error.${error.response.data.result.key || "generic"}`))
    }
  }

  return (
    <div className="col-12">
      <div className="row m-0">
        <div className="col-lg-6 pt-1 pl-0">
          <h6 className="Bold">{t('services')}</h6>
        </div>
        <div className="col-lg-6 text-right">
          <ButtonIcon handleClick={() => { ClickSettings("new") }} icon="add" />
        </div>
      </div>
      {reorderedCategories.map((param: any, index: any) =>
        <BoxService
          key={index}
          external={param.external}
          deletable={param.deletable}
          disabled={param.disabled}
          groupLink={param.groupLink}
          handleClickEdit={ClickEdit}
          handleClickSettings={ClickSettings}
          handleDelete={deleteCategoryPrenotation}
          id={param._id}
          title={param.name}
          toggleClick={toggleviewListServiceTimeslot} />
      )
      }
      <AlertMessageModal
        title={t('attention')}
        description={errorMessage}
        closeModal={() => (setErrorMessage(""))}
        show={errorMessage} />
      <AlertMessageModal
        title={t('delete')}
        description={t('timeslot-category-delete', { name: nameDeleteCategoryPrenotation })}
        closeModal={() => { setIdDeleteCategoryPrenotation("") }}
        titleButtonPrimary={t('delete')}
        handleClosePrimary={() => { deleteTimeslotCategorie(); }}
        titleButtonSecondary={t('cancel')}
        handleCloseSecondary={() => { setIdDeleteCategoryPrenotation("") }}
        show={idDeleteCategoryPrenotation}
        spinnerButtonSecondary={loaderDelete} />

      {groupLinkValueNewActivation && <NewGroupLinkModal
        groupLinkValueNewActivation={groupLinkValueNewActivation}
        onClose={() => setGroupLinkValueNewActivation(null)}
      />}
    </div>
  )
}

export default ListServiceTimeslot